import { LINKEDIN_PAGE_VIEWS_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function linkedinPageViews(state=INITIAL_STATE, action) {
 
  switch(action.type) {
    case LINKEDIN_PAGE_VIEWS_SUCCESS:
    //  console.log("data inside reducer after the ajax call =  ", action.type)
    //   // const parsedData = JSON.parse(action.payload.data)
    //   console.log("statesd", state)
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}